import { ApplicationConfig, provideZoneChangeDetection, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { MessageService } from 'primeng/api';
import Aura from '@primeng/themes/aura';
import {definePreset} from '@primeng/themes';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { LoaderInterceptor } from './interceptor/loader.interceptor';
import { authTokenInterceptor } from './interceptor/auth-token.interceptor';
import { provideServiceWorker } from '@angular/service-worker';

const MyPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '{blue.50}',
            100: '{blue.100}',
            200: '{blue.300}',
            300: '{blue.500}',
            400: '{blue.600}',
            500: '{blue.900}',
            600: '{blue.950}',
            700: '{blue.950}',
            800: '{blue.950}',
            900: '{blue.950}',
            950: '{blue.950}'
        }
    }
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptors([authTokenInterceptor, LoaderInterceptor])),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    providePrimeNG({ 
      theme: {
        preset: MyPreset,
        options: {
          darkModeSelector: false 
        }
      }
    }),
    MessageService, 
    provideServiceWorker('background-sync.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:30000'
          })
  ]
};
